export default "__VITE_ASSET__ZJy6m857__"